<div class="main-container-edit">
    <mat-toolbar color="primary" >
        <div class="toolbar-title">
            <span>{{'translate.title.ai'|translateTA}}</span>
        </div>
    </mat-toolbar>
    <mat-divider></mat-divider>
    <div class="form-container-main">
        <form [formGroup]="formGroup" class="form-container">
            <mat-form-field appearance="outline" ngClass="no-padding-form-field formviewclass" >
                <mat-label>{{'translate.ia.destino'|translateTA}}</mat-label>
                <mat-select  formControlName="origem" [disabled]="true" #origemSelect>
                    <mat-option *ngFor="let item of languages" [value]="item.col">
                        {{item.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-divider></mat-divider>
            <mat-form-field appearance="outline" ngClass="no-padding-form-field formviewclass">
                <mat-label>{{'translate.ia.destino'|translateTA}}</mat-label>
                <mat-select  formControlName="destino" #destinoSelect>
                    <mat-option *ngFor="let item of languages|arrayFilter:'col':'PTBR':true:true" [value]="item.col">
                        {{item.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </form>
    </div>
    <mat-divider></mat-divider>
    <mat-toolbar color="primary" class="toolbar-action" >
        <div class="spacer"></div>
        <button  mat-mini-fab color="success" [disabled]="!canDelete"  (click)="translateItens()" matTooltip="{{'actions.ia'|translateTA}}">
            <mat-icon>neurology</mat-icon> 
        </button>
    </mat-toolbar>
    <div class="list-ai-select">
        <mat-selection-list #filterList [multiple]="false">
            <mat-list-item *ngFor="let item of arrayList"  [value]="item.guid">

                <div class="item-ai"  [ngClass]="{'odd': item.index % 2 !== 0, 'even': item.index % 2 === 0}">
                
                    <div class="item-ai-info">
                        <span>{{item[origemSelect.value]}}</span>-<span>({{getCountIds(item.guid)}})</span>  
                    </div>

                    <div class="form-field-density-4 full-width">
                        <mat-form-field class="no-padding-form-field" *ngIf="destinoSelect.value!=null">
                            <input  matInput type="text"  #value required  [(ngModel)]="item[destinoSelect.value]"   (click)="$event.stopPropagation()" (ngModelChange)="changingTranslation(item)"/>
                        </mat-form-field>
                    </div>
                    
                    <mat-icon class="cancel" (click)="removeFile(item.guid)"
                    *ngIf="(item[destinoSelect.value]==''||item[destinoSelect.value]==null) && canDelete">delete_forever</mat-icon>

                    <mat-icon class="waiting" 
                    *ngIf="(item[destinoSelect.value]==''||item[destinoSelect.value]==null) && !canDelete">schedule</mat-icon>

                    <!--fa-icon  [icon]="faCircleNotch" [spin]="true" class="process" *ngIf="item.translating==true" ></fa-icon-->
                    <mat-icon class="process" 
                    *ngIf="item.translating==true"><mat-spinner color="primary" diameter="20">
                </mat-spinner></mat-icon>


                    <mat-icon class="error" [matTooltip]="item.error"
                    *ngIf="(item.error!=null)">warning</mat-icon>
                    
                 
                    <mat-icon class="done"  
                    *ngIf="item.translating == false && item[destinoSelect.value]!=null && item[destinoSelect.value]!='' && (item.error==null)">check_circle</mat-icon>
                    

                </div>
                <!--div>
                    <b>{{item.text}}</b> - {{getCountIds(item.guid)}} {{'lines'|translateTA}}
                </div-->
            </mat-list-item>
        </mat-selection-list>
    </div>
    <actions-buttons [buttonList]="buttonList"></actions-buttons>
</div>